import { AdRequestFormatTemplate, Platform } from "@app/core";
import { Parameter } from "@app/core/models/parameter.model";
import { ApiBind, Common } from "./common.model";

/**
 * 広告リクエストパラメータテンプレートのパラメータを表すモデル
 *
 * @exports
 */
export class AdRequestParameterTemplateParameter extends Parameter {}

/**
 * 広告リクエストパラメータテンプレートクラス
 * @remarks
 * 広告リクエストパラメータテンプレートの情報を格納するクラス
 */
export class AdRequestParameterTemplate extends Common {
    // ID
    @ApiBind({ column: 'id' })
    id: number;
    // 広告リクエストパラメータテンプレート名
    @ApiBind({ column: 'name' })
    name: string;
    // プラットフォーム
    @ApiBind({ column: 'platform' , model: (value) =>  new Platform(value) })
    platform: Platform;
    // 広告リクエストフォーマットテンプレート
    @ApiBind({ column: 'ad_request_format_template', model: (value) =>  new AdRequestFormatTemplate(value) })
    adRequestFormatTemplate: AdRequestFormatTemplate;
    // 広告リクエストパラメータ
    @ApiBind({ column: 'parameters' , model: (value) => value.map(v => new AdRequestParameterTemplateParameter(v)) })
    parameters: AdRequestParameterTemplateParameter[];
    // 更新時刻
    @ApiBind({ column: 'updated_at' })
    updatedAt: string;

    /**
     * 新規作成・編集時に広告リクエストパラメータテンプレートのリクエスト情報をJSONに変換
     * @returns {name :any , platform_id: any, ad_request_format_template_id: any, parameters: amy[], updated_at: any} 新規作成・編集時にリクエストで送るJSON
     */
    public toCreateEditItemJson() {
        return {
            name:this.convertJSONObject(this.name),
            platform_id: this.convertJSONObject(this.platform.id),
            ad_request_format_template_id: this.convertJSONObject(this.adRequestFormatTemplate.id),
            parameters: this.parameters.map(parameter => this.convertJSONObject(parameter)),
            updated_at: this.convertJSONObject(this.updatedAt)
        };
    }

    /**
     * 削除時に広告リクエストパラメータテンプレートの情報をJSONに変換
     * @returns {id :any , updated_at: any} 削除時にリクエストで送るJSON
     */
    public toDeleteItemJSON() {
        return { id: this.convertJSONObject(this.id), updated_at: this.convertJSONObject(this.updatedAt) };
    }
}
